import * as React from "react";
import { Building2, Heart, MapPin } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
const partners = [];
export default function PartnerApartments() {
  return <section data-section-id="223888" id="community-trust" className="py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center text-center max-w-3xl mx-auto mb-16">
          <Badge variant="secondary" className="mb-4 bg-primary text-primary-foreground rounded-full px-4 py-1 font-default uppercase tracking-wider text-xs">
            Verified & Local
          </Badge>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-primary mb-4 tracking-tighter">
            Community Trust & Credentials
          </h2>
          <p className="text-lg text-primary font-serif leading-relaxed">
            Peace River Pest Control is proud to be a fully insured, FDACS licensed operator. Our commitment to Punta Gorda is backed by local partnerships and industry excellence.
          </p>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
          {partners.map((partner, i) => <div key={partner.name} data-index={i} className="break-inside-avoid">
              <Card className="group relative overflow-hidden border-2 border-primary shadow-none hover:bg-primary transition-all duration-500 bg-card rounded-none">
                
                
                <CardHeader className="pb-6 group-hover:text-primary-foreground transition-colors duration-500">
                  <CardTitle className="font-default text-xl mb-1 uppercase tracking-tight">
                    {partner.name}
                  </CardTitle>
                  <CardDescription className="flex items-center gap-1.5 text-sm font-default group-hover:text-primary-foreground/80">
                    <MapPin className="w-3.5 h-3.5" />
                    {partner.location}
                  </CardDescription>
                </CardHeader>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}